export default "__VITE_ASSET__1OlRkj5H__"